<template>
  <div :class="['countdown', classes, { divider }]">
    <div class="box days">
      <div>
        <span class="number">{{ countdown.days }}</span>
        <span class="label">Days</span>
      </div>
    </div>
    <span v-if="divider" class="divider-sign">:</span>
    <div class="box hours">
      <div>
        <span class="number">{{ countdown.hours }}</span>
        <span class="label">Hours</span>
      </div>
    </div>
    <span v-if="divider" class="divider-sign">:</span>
    <div class="box minutes">
      <div>
        <span class="number">{{ countdown.minutes }}</span>
        <span class="label">Minutes</span>
      </div>
    </div>
    <span v-if="divider" class="divider-sign">:</span>
    <div class="box seconds">
      <div>
        <span class="number">{{ countdown.seconds }}</span>
        <span class="label">Seconds</span>
      </div>
    </div>
  </div>
</template>

<script>
import { countDownToDate } from './utils/helper';

export default {
  props: {
    endDate: { type: Date, default: null, required: true },
    classes: { type: String, default: '', required: false },
    divider: { type: Boolean },
  },
  data() {
    return {
      countdown: this.getCountdownToDate(),
    };
  },
  mounted() {
    if (this.endDate && this.endDate.toString() === 'Invalid Date') {
      return;
    }

    const x = setInterval(() => {
      this.countdown = this.getCountdownToDate();
      if (!this.countdown) {
        clearInterval(x);
        this.$emit('expired');
      }
    }, 1000);
  },
  methods: {
    getCountdownToDate() {
      return countDownToDate(new Date(), this.endDate) || {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.countdown {
  display: inline-flex;
  justify-content: space-between;
  color: var(--extreme-blue-2);

  &.divider {
    align-items: center;
  }

  .box {
    display: flex;
    width: 80px;
    height: 81px;
    text-align: center;
    align-items: center;
    font-weight: 400;
    line-height: 1;
    border: 1.5px solid transparent;
    border-radius: 10px;

    .number {
      display: inline-block;
      width: 100%;
      font-size: 40px;
      text-align: left;
      padding: 0 0 0 14px;
    }

    .label {
      font-size: 14px;
    }

    + .box {
      margin-left: 10px;
    }
  }

  .divider-sign {
    margin: 0 var(--spacing-8);
    font-size: 32px;
    font-weight: 500;
  }

  &.bordered {
    .box {
      border-color: var(--extreme-blue-2);
    }
  }

  @include bp($bp-laptop) {
    .box {
      width: 64px;
      height: 67px;

      .number {
        font-size: 32px;
        padding: 0 0 0 12px;
      }

      .label {
        font-size: 12px;
      }

      + .box {
        margin-left: 8px;
      }
    }
  }

  @include bp($bp-mobile) {
    .box {
      width: 64px;
      height: 67px;

      .number {
        font-size: 32px;
        padding: 0 0 0 12px;
      }

      .label {
        font-size: 12px;
      }

      + .box {
        margin-left: 8px;
      }
    }
  }
}
</style>
